import { render, staticRenderFns } from "./address-renderer.vue?vue&type=template&id=20062862&"
import script from "./address-renderer.vue?vue&type=script&lang=js&"
export * from "./address-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports